






































import { createComponent, ref, inject, computed } from '@vue/composition-api'
import { MainMapControllerSymbol } from '@/symbols'
import { MapFactoryController } from '@/lib/map'

import SwitchMapModeButton from '@/components/SwitchMapModeButton.vue'

export default createComponent({
  name: 'DisplaySettingBottomSheet',
  components: {
    SwitchMapModeButton
  },
  setup () {
    const isOpen = ref(false)
    const mapController = inject(MainMapControllerSymbol, ref<MapFactoryController>())

    const isLUIMapVisable$ = ref(false)
    const isLUIMapVisable = computed({
      get: () => {
        isLUIMapVisable$.value = !!mapController.value?.mapInstance.getLUILayerVisible()

        return isLUIMapVisable$.value
      },
      set: (value) => {
        mapController.value?.mapInstance.setLUILayerVisible(value)
        isLUIMapVisable$.value = value
      }
    })

    return {
      isOpen,
      isLUIMapVisable
    }
  }
})
